export interface FaqGroup {
  title: string;
  icon: string;
  items: { q: string; a: string }[];
}

export const faqGroups: FaqGroup[] = [
  {
    title: '关于内容',
    icon: 'ri-article-line',
    items: [
      {
        q: '吃瓜网主要写什么内容？',
        a: '我们目前分为娱乐热点、热剧综、网络热梗和瓜圈观察四个栏目，分别对应娱乐行业现象、剧集综艺观察、流行语传播和围观方法论四类内容。所有文章都围绕一个具体话题展开，尽量给出完整的背景和清楚的线索。',
      },
      {
        q: '内容会涉及未经证实的传闻吗？',
        a: '不会。我们明确区分事实与猜测，无法核实的私人消息不做传播。如果某个话题目前信息不足，我们会选择不写，或者只写已经可以确认的部分，并标注清楚边界。',
      },
      {
        q: '文章会持续更新吗？',
        a: '会。如果一件事情有了新进展，我们会优先在原文中补充或修正，而不是另发一篇高度重复的内容。你也可以通过每篇文章标注的更新日期，判断它是否是最新版。',
      },
      {
        q: '发现问题怎么反馈？',
        a: '可以通过联系页面留言，或直接发送邮件到 hello@chigua-wang.com。告诉我们具体是哪一篇、哪一段，我们会尽快核实并处理。',
      },
    ],
  },
  {
    title: '关于阅读',
    icon: 'ri-book-open-line',
    items: [
      {
        q: '阅读需要付费或者注册吗？',
        a: '不需要。站内所有文章都可以直接浏览，没有付费墙、不需要登录、也没有阅读次数限制。你可以自由地在栏目之间跳转，把感兴趣的内容从头看到尾。',
      },
      {
        q: '手机上阅读体验如何？',
        a: '页面针对手机、平板和电脑都做了适配。移动端可以展开导航菜单，文章目录、标签筛选和返回顶部等功能在手机上同样可以使用，版式会自动调整到适合屏幕的宽度。',
      },
      {
        q: '怎样才能快速找到想看的话题？',
        a: '可以使用页面顶部的搜索框输入关键词，也可以用站内搜索页按标题、摘要和标签进行匹配。分类页里还提供了按标签筛选，方便你在一个栏目内快速缩小范围。',
      },
      {
        q: '可以订阅更新提醒吗？',
        a: '可以。首页底部提供了免费的邮件订阅入口，留下邮箱后，我们会在新内容上线时发送一篇简短提醒。订阅完全自愿，随时可以取消。',
      },
    ],
  },
  {
    title: '关于参与',
    icon: 'ri-chat-smile-2-line',
    items: [
      {
        q: '可以在评论区讨论吗？',
        a: '目前站内以阅读为主，暂未开放公开评论区。我们更希望你通过留言或邮件把想法直接告诉我们，包括选题建议、内容纠错和不同的观点，这些都会被编辑部认真阅读。',
      },
      {
        q: '怎样才算是理性的围观？',
        a: '简单说就是三个动作：先区分事实和猜测，讨论行为而不是攻击个人，在信息不全时允许自己先不下结论。我们有一篇《吃瓜的正确姿势》专门讲了这件事，欢迎读完再来和我们对答案。',
      },
      {
        q: '可以投稿或者合作吗？',
        a: '可以。如果你有想聊的选题，或者希望与我们进行内容层面的合作，请通过联系页面留言并选择对应类型，简单说明你的想法和联系方式，我们会尽快回复。',
      },
    ],
  },
];